export default __webpack_public_path__ + "static/media/3.5bd9a64b.webp";